import React from "react";
import {Route, Redirect} from 'react-router-dom'

function ProtectedRoute({ component: Component, ...rest }) {

    return <Route {...rest} render={(props)=> {
        if (localStorage.getItem('userdata')) {
            return <Component />
        }
        else {
            return <Redirect to="/" />
        }
    }} />
}

export default ProtectedRoute;